import { render, staticRenderFns } from "./Epassport.vue?vue&type=template&id=4946a272&scoped=true&"
import script from "./Epassport.vue?vue&type=script&lang=js&"
export * from "./Epassport.vue?vue&type=script&lang=js&"
import style0 from "./Epassport.vue?vue&type=style&index=0&id=4946a272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4946a272",
  null
  
)

export default component.exports